"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricDrawingManager = void 0;
const react_1 = __importDefault(require("react"));
const FabricDrawControl_1 = __importDefault(require("./FabricDrawControl"));
const layers_1 = require("../layers");
const utils_1 = require("../../utils");
const geometry_engine_1 = __importDefault(require("../../utils/drawing-manager/tools/esri/geometry-engine"));
const util_1 = require("../util");
const tools_1 = require("../../utils/drawing-manager/tools");
const BufferModal_1 = require("./buffer-tool-modal/BufferModal");
const DEFAULT_DISABLE_MOVE_FEATURE = false;
const DEFAULT_DISABLE_CLICK_TO_SELECT = false;
class FabricDrawingManager extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.disableClickToSelect = DEFAULT_DISABLE_CLICK_TO_SELECT;
        /**
         * Take a partial from state and update state with it.
         */
        this.updateState = (update) => {
            this.setState((current) => (Object.assign(Object.assign({}, current), update)));
        };
        /**
         * Because updateState never changes, this is a wrapper around onUpdate that can be called all over.
         */
        this.internalUpdate = !this.props.onUpdate
            ? null
            : (layer) => {
                this.props.onUpdate &&
                    this.props.onUpdate(layer, this.updateState, this.state);
            };
        this.onUndo = () => {
            var _a, _b;
            const { undo, redo, currentMode } = this.state;
            if (undo.length) {
                const features = undo.pop();
                if (features) {
                    redo.push(this.state.layer);
                    this.setState(Object.assign(Object.assign({}, this.state), { layer: features, currentMode: utils_1.DrawingMode.SIMPLE_SELECT }));
                    if (this.internalUpdate) {
                        this.internalUpdate(features);
                    }
                    if (currentMode !== utils_1.DrawingMode.SIMPLE_SELECT) {
                        (_b = (_a = this.props).onDrawModeChange) === null || _b === void 0 ? void 0 : _b.call(_a, utils_1.DrawingMode.SIMPLE_SELECT, currentMode);
                    }
                }
            }
        };
        this.onRedo = () => {
            var _a, _b;
            const { undo, redo, currentMode } = this.state;
            if (redo.length) {
                const features = redo.pop();
                if (features) {
                    undo.push(this.state.layer);
                    this.setState(Object.assign(Object.assign({}, this.state), { layer: features, currentMode: utils_1.DrawingMode.SIMPLE_SELECT }));
                    if (this.internalUpdate) {
                        this.internalUpdate(features);
                    }
                    if (currentMode !== utils_1.DrawingMode.SIMPLE_SELECT) {
                        (_b = (_a = this.props).onDrawModeChange) === null || _b === void 0 ? void 0 : _b.call(_a, utils_1.DrawingMode.SIMPLE_SELECT, currentMode);
                    }
                }
            }
        };
        this.onFeaturesUpdated = (features, toMode = utils_1.DrawingMode.SIMPLE_SELECT) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const { currentMode } = this.state;
            this.state.redo.length = 0;
            this.state.undo.push(this.state.layer);
            this.setState(Object.assign(Object.assign({}, this.state), { layer: features, currentMode: toMode }));
            if (this.internalUpdate) {
                this.internalUpdate(features);
            }
            if (currentMode !== toMode) {
                (_b = (_a = this.props).onDrawModeChange) === null || _b === void 0 ? void 0 : _b.call(_a, toMode, currentMode);
            }
        });
        this.onCreateAddBufferStrip = (bufferSize, uom) => __awaiter(this, void 0, void 0, function* () {
            if (bufferSize && uom && this.state.drawnFeatures) {
                const results = yield tools_1.addBufferStripTool.createAddStripBuffer(this.state.layer, this.state.drawnFeatures, bufferSize, uom, this.boundary);
                this.onFeaturesUpdated(results);
                this.setState(Object.assign(Object.assign({}, this.state), { showAddBufferStripModal: false, disableHighlight: true }));
            }
        });
        this.onCancelAddBufferStrip = () => {
            this.setState(Object.assign(Object.assign({}, this.state), { showAddBufferStripModal: false, disableHighlight: true }));
        };
        this.onCreateCutBufferStrip = (bufferSize, uom) => __awaiter(this, void 0, void 0, function* () {
            if (bufferSize && uom && this.state.drawnFeatures) {
                const results = yield tools_1.cutBufferStripTool.createCutStripBuffer(this.state.layer, this.state.drawnFeatures, bufferSize, uom);
                this.onFeaturesUpdated(results);
                this.setState(Object.assign(Object.assign({}, this.state), { showCutBufferStripModal: false, disableHighlight: true }));
            }
        });
        this.onCancelCutBufferStrip = () => {
            this.setState(Object.assign(Object.assign({}, this.state), { showCutBufferStripModal: false }));
        };
        this.onCreateBuffer = (bufferSize, uom) => __awaiter(this, void 0, void 0, function* () {
            if (bufferSize && uom && this.boundary) {
                const tool = (0, utils_1.getDrawingTool)(utils_1.DrawingMode.DRAW_FIELD_POLYGON_BUFFER);
                const results = yield tool.createBufferPolygon(this.boundary, bufferSize, uom);
                yield this.onFeaturesUpdated(results, utils_1.DrawingMode.SIMPLE_SELECT);
            }
            this.setState(Object.assign(Object.assign({}, this.state), { showBufferModal: false }));
        });
        this.onDrawCreate = (mode, drawFeatures, api) => __awaiter(this, void 0, void 0, function* () {
            const currentFeatures = this.state.layer;
            const tool = (0, utils_1.getDrawingTool)(mode);
            switch (mode) {
                case utils_1.DrawingMode.DRAW_LINE_STRING_ADD_POLYGON_BUFFER: {
                    yield tool.onComplete(this.state.layer, drawFeatures);
                    api.deleteAll();
                    this.setState(Object.assign(Object.assign({}, this.state), { drawnFeatures: drawFeatures, showAddBufferStripModal: true, disableHighlight: true }));
                    break;
                }
                case utils_1.DrawingMode.DRAW_LINE_STRING_CUTTING_STRIP: {
                    yield tool.onComplete(this.state.layer, drawFeatures);
                    api.deleteAll();
                    this.setState(Object.assign(Object.assign({}, this.state), { drawnFeatures: drawFeatures, showCutBufferStripModal: true, disableHighlight: true }));
                    break;
                }
                case utils_1.DrawingMode.SCALE_ROTATE:
                case utils_1.DrawingMode.FEATURE_EDIT: {
                    const features = yield tool.onComplete(this.state.layer, drawFeatures, this.boundary);
                    if (features !== this.state.layer) {
                        yield this.onFeaturesUpdated(features, mode);
                    }
                    break;
                }
                default:
                    if (tool && utils_1.drawingModeOptions[mode].processOnCreate) {
                        const features = yield tool.onComplete(currentFeatures, drawFeatures, this.boundary);
                        yield this.onFeaturesUpdated(features);
                        api.deleteAll();
                    }
                    else {
                        console.warn(`Tool not defined for ${mode} mode`);
                    }
                    break;
            }
        });
        this.onChangeDrawMode = (mode, api) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const { currentMode } = this.state;
            console.log(`current mode: ${currentMode}`);
            console.log(`changing to mode: ${mode}`);
            switch (mode) {
                case utils_1.DrawingMode.UNDO:
                    this.onUndo();
                    break;
                case utils_1.DrawingMode.REDO:
                    this.onRedo();
                    break;
                case utils_1.DrawingMode.TRASH:
                    api.changeMode(mode);
                    this.setState(Object.assign(Object.assign({}, this.state), { currentMode: mode, disableHighlight: false }));
                    (_b = (_a = this.props).onDrawModeChange) === null || _b === void 0 ? void 0 : _b.call(_a, mode, currentMode);
                    break;
                case utils_1.DrawingMode.FEATURE_EDIT:
                    this.setState(Object.assign(Object.assign({}, this.state), { currentMode: mode, disableHighlight: true }));
                    api.changeMode(utils_1.DrawingMode.FEATURE_EDIT);
                    (_d = (_c = this.props).onDrawModeChange) === null || _d === void 0 ? void 0 : _d.call(_c, mode, currentMode);
                    break;
                case utils_1.DrawingMode.SCALE_ROTATE:
                    this.setState(Object.assign(Object.assign({}, this.state), { currentMode: mode, disableHighlight: true }));
                    api.changeMode(utils_1.DrawingMode.SCALE_ROTATE);
                    (_f = (_e = this.props).onDrawModeChange) === null || _f === void 0 ? void 0 : _f.call(_e, mode, currentMode);
                    break;
                case utils_1.DrawingMode.DRAW_FIELD_POLYGON_BUFFER:
                    api.changeMode(utils_1.DrawingMode.SIMPLE_SELECT);
                    this.setState(Object.assign(Object.assign({}, this.state), { currentMode: utils_1.DrawingMode.SIMPLE_SELECT, showBufferModal: true, disableHighlight: true }));
                    (_h = (_g = this.props).onDrawModeChange) === null || _h === void 0 ? void 0 : _h.call(_g, mode, currentMode);
                    break;
                case utils_1.DrawingMode.SIMPLE_SELECT:
                default:
                    api.changeMode(mode);
                    this.setState(Object.assign(Object.assign({}, this.state), { currentMode: mode, disableHighlight: true }));
                    (_k = (_j = this.props).onDrawModeChange) === null || _k === void 0 ? void 0 : _k.call(_j, mode, currentMode);
            }
        };
        this.onClick = (feature) => __awaiter(this, void 0, void 0, function* () {
            var _c, _d;
            const { currentMode, layer } = this.state;
            switch (currentMode) {
                case utils_1.DrawingMode.TRASH: {
                    const newLayer = yield tools_1.trashTool.onComplete(layer, feature);
                    const toMode = newLayer.features.length
                        ? currentMode
                        : utils_1.DrawingMode.SIMPLE_SELECT;
                    yield this.onFeaturesUpdated(newLayer, toMode);
                    break;
                }
                case utils_1.DrawingMode.SIMPLE_SELECT: {
                    if (!this.disableClickToSelect) {
                        // This makes it so if we're not in feature edit mode and click a feature,
                        // we'll jump into feature edit mode so users don't have to click the pencil
                        const toMode = utils_1.DrawingMode.FEATURE_EDIT;
                        this.setState(Object.assign(Object.assign({}, this.state), { currentMode: toMode, disableHighlight: true }));
                        yield ((_d = (_c = this.props).onDrawModeChange) === null || _d === void 0 ? void 0 : _d.call(_c, toMode, currentMode));
                    }
                    break;
                }
                default:
                    break;
            }
        });
        this.render = () => {
            var _a, _b, _c, _d;
            const { layer, disableHighlight, currentMode, undo, redo, showBufferModal, showAddBufferStripModal, showCutBufferStripModal, } = this.state;
            const { controls, drawStyles, hideControls, layerPaint, iconSize, useLayerBoundary, defaultMode, clickBuffer, touchBuffer, disableDragFeature, } = this.props;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                useLayerBoundary && this.boundary && (react_1.default.createElement(layers_1.FabricMapLayer, { disableHighlight: disableHighlight, layer: this.boundary, paint: {
                        "fill-opacity": 0,
                    } })),
                !hideControls && (react_1.default.createElement(FabricDrawControl_1.default, { controls: controls, onDrawCreate: this.onDrawCreate, onChangeDrawMode: this.onChangeDrawMode, layer: layer, currentMode: currentMode, undo: undo, redo: redo, styles: drawStyles, iconSize: iconSize, defaultMode: defaultMode, clickBuffer: clickBuffer, touchBuffer: touchBuffer, showMeasurements: this.props.showMeasurements, measurementUnits: ((_a = this.props.measurementsConfig) === null || _a === void 0 ? void 0 : _a.uom) ||
                        utils_1.MeasurementUnitOfMeasure.IMPERIAL, disableDragFeature: disableDragFeature !== null && disableDragFeature !== void 0 ? disableDragFeature : DEFAULT_DISABLE_MOVE_FEATURE })),
                react_1.default.createElement(util_1.Conditional, { match: currentMode !== utils_1.DrawingMode.FEATURE_EDIT &&
                        currentMode !== utils_1.DrawingMode.SCALE_ROTATE },
                    react_1.default.createElement(layers_1.FabricMapLayer, { disableHighlight: disableHighlight, layer: layer, onMouseClick: this.onClick, paint: layerPaint, id: "fabric-drawing-manager" })),
                react_1.default.createElement(BufferModal_1.BufferModal, { isOpen: showBufferModal || false, onCancel: this.onCreateBuffer, onCreate: this.onCreateBuffer, uom: ((_b = this.props.measurementsConfig) === null || _b === void 0 ? void 0 : _b.uom) ||
                        utils_1.MeasurementUnitOfMeasure.IMPERIAL, cuttingStripMode: BufferModal_1.BufferMode.FIELD }),
                react_1.default.createElement(BufferModal_1.BufferModal, { isOpen: showCutBufferStripModal || false, onCancel: this.onCancelCutBufferStrip, onCreate: this.onCreateCutBufferStrip, uom: ((_c = this.props.measurementsConfig) === null || _c === void 0 ? void 0 : _c.uom) ||
                        utils_1.MeasurementUnitOfMeasure.IMPERIAL, cuttingStripMode: BufferModal_1.BufferMode.CUT }),
                react_1.default.createElement(BufferModal_1.BufferModal, { isOpen: showAddBufferStripModal || false, onCancel: this.onCancelAddBufferStrip, onCreate: this.onCreateAddBufferStrip, uom: ((_d = this.props.measurementsConfig) === null || _d === void 0 ? void 0 : _d.uom) ||
                        utils_1.MeasurementUnitOfMeasure.IMPERIAL, cuttingStripMode: BufferModal_1.BufferMode.ADD })));
        };
        this.state = {
            layer: props.startWithBaseLayer && props.layer
                ? props.layer
                : {
                    type: "FeatureCollection",
                    features: [],
                },
            disableHighlight: true,
            currentMode: utils_1.DrawingMode.SIMPLE_SELECT,
            undo: [],
            redo: [],
        };
        if (props.disableClickToSelect !== undefined) {
            this.disableClickToSelect = props.disableClickToSelect;
        }
        //prefetching arcgis geometry engine
        geometry_engine_1.default.instance();
        //creating a boundary with base layer
        this.boundary =
            props.useLayerBoundary && props.layer
                ? utils_1.GeoJsonUtils.union(props.layer)
                : undefined;
    }
}
exports.FabricDrawingManager = FabricDrawingManager;
FabricDrawingManager.getDerivedStateFromProps = (props, state) => props.getDerivedStateFromProps
    ? props.getDerivedStateFromProps(props, state)
    : null;
